<div class="table-wrapper">
  <div class="table-container">
    @if (loading) {
    <div class="table-loading">
      <div class="loading-spinner"></div>
      <span>Loading...</span>
    </div>
    } @else {
    <table class="lib-table" [class.striped]="striped" [class.hoverable]="hoverable">
      <thead>
        <tr>
          @for (column of columns; track trackByColumnKey($index, column)) {
          <th
            [style.width]="column.width"
            [style.text-align]="column.align || 'left'"
            [class.sortable]="column.sortable"
          >
          @if (headerTemplate) {
          <ng-container [ngTemplateOutlet]="headerTemplate" [ngTemplateOutletContext]="{ $implicit: column, index: $index }"></ng-container>
          } @else {
          {{ column.label }}
          }
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @if (data.length === 0) {
        <tr>
          <td [attr.colspan]="columns.length" class="table-empty">
            {{ emptyMessage }}
          </td>
        </tr>
        } @else {
        @for (row of data; track trackByIndex($index, row)) {
        <tr>
          @if (rowTemplate) {
          <ng-container [ngTemplateOutlet]="rowTemplate" [ngTemplateOutletContext]="{ $implicit: row, index: $index }"></ng-container>
          } @else {
          @for (column of columns; track trackByColumnKey($index, column)) {
          <td
            [style.text-align]="column.align || 'left'"
          >
            @if (cellTemplate) {
            <ng-container [ngTemplateOutlet]="cellTemplate" [ngTemplateOutletContext]="{ $implicit: getColumnValue(row, column), row: row, column: column, index: $index }"></ng-container>
            } @else {
            {{ getColumnValue(row, column) }}
            }
          </td>
          }
          }
        </tr>
        }
        }
      </tbody>
    </table>
    }
  </div>
</div>

